export const FORMAT_TIME = 'hh:mm A';

export const DATE_FORMAT = 'MM-DD-YYYY';
export const DATE_FORMAT_VIEW = 'MM/DD/YYYY';